<template>
  <div class="w-chat" v-if="user && isReady">
    <chat-window
      :currentUserId="user.id"
      :rooms="rooms"
      :activeRoom="activeRoom"
      :messages="mappedMessages"
      :messagesLoaded="messagesLoaded"
      :loadingRooms="loadingRooms"
      :menuActions="menuActions"
      :showFiles="false"
      :textMessages="textMessages"
      @openRoom="chatSetActiveRoom"
      @closeRoom="closeRoom"
      @fetchMessages="fetchMessagesDebounced"
      @sendMessage="sendMessage"
      @menuActionHandler="menuActionHandler"
      @windowStatus="windowStatus"
    >
      <template v-slot:rooms-header>
        <OnlineCard @openChat="openChat"></OnlineCard>
      </template>

      <template v-slot:room-box-footer>
        <RoomBoxFooter
          v-if="activeRoom && !activeRoom.profile.is_admin"
          :currentUserId="user.id"
          :coins="totalCoinsValue"
          :activeRoom="activeRoom"
          :textMessages="textMessages"
          @sendMessage="sendMessage"
          @unBlockMember="unBlockMember"
        >
          <template v-slot:room-buttons>
            <button class="svg-button" @click="toggleImageGallery()">
              <svg id="picture" xmlns="http://www.w3.org/2000/svg" width="32.022" height="22.415" viewBox="0 0 32.022 22.415">
                <g id="Group_77" data-name="Group 77" transform="translate(0 0)">
                  <g id="Group_76" data-name="Group 76" transform="translate(0 0)">
                    <path
                      id="Path_146"
                      data-name="Path 146"
                      d="M29.354,72H2.669A2.672,2.672,0,0,0,0,74.669V91.747a2.672,2.672,0,0,0,2.669,2.668H29.354a2.47,2.47,0,0,0,.447-.039,2.661,2.661,0,0,0,2.222-2.63V74.669A2.672,2.672,0,0,0,29.354,72ZM2.669,93.348a1.6,1.6,0,0,1-1.595-1.46l10.641-6.957,10.821,8.418Zm28.286-1.6a1.6,1.6,0,0,1-1.34,1.578,1.452,1.452,0,0,1-.262.023H24.274l-7.071-5.5,6.323-5.056,7.428,4.457Zm0-5.746-7.2-4.318a.534.534,0,0,0-.608.041l-6.814,5.449-4.267-3.319a.534.534,0,0,0-.619-.026L1.067,90.617V74.669a1.6,1.6,0,0,1,1.6-1.6H29.354a1.6,1.6,0,0,1,1.6,1.6Z"
                      transform="translate(0 -72)"
                      fill="#adacac"
                    />
                    <path
                      id="Path_147"
                      data-name="Path 147"
                      d="M195.2,120a3.2,3.2,0,1,0,3.2,3.2A3.2,3.2,0,0,0,195.2,120Zm0,5.337a2.135,2.135,0,1,1,2.135-2.135A2.135,2.135,0,0,1,195.2,125.337Z"
                      transform="translate(-179.191 -116.798)"
                      fill="#adacac"
                    />
                  </g>
                </g>
              </svg>
            </button>

            <button class="svg-button" @click="toggleGiftGallery()">
              <svg id="surface1" xmlns="http://www.w3.org/2000/svg" width="25.623" height="25.624" viewBox="0 0 25.623 25.624">
                <path
                  id="Path_141"
                  data-name="Path 141"
                  d="M24.342,4.271H19.805A3.1,3.1,0,0,0,19.221.816,3.1,3.1,0,0,0,17.052,0h0a4.807,4.807,0,0,0-3.261,1.4,5,5,0,0,0-.976,1.29A4.983,4.983,0,0,0,11.837,1.4,4.806,4.806,0,0,0,8.574,0h0A3.1,3.1,0,0,0,6.4.816a3.1,3.1,0,0,0-.584,3.456H1.281A1.281,1.281,0,0,0,0,5.553v5.979a1.281,1.281,0,0,0,1.281,1.281h.427V24.343a1.281,1.281,0,0,0,1.281,1.281H23.061a.854.854,0,0,0,.854-.854V12.813h.854a.854.854,0,0,0,.854-.854V5.553A1.281,1.281,0,0,0,24.342,4.271ZM14.489,2A3.661,3.661,0,0,1,17.013.855a2.043,2.043,0,0,1,1.486.569,2.5,2.5,0,0,1,.246,2.847h-5.1l-.244-.3A3.872,3.872,0,0,1,14.489,2Zm.458,22.77H10.676V5.126h4.271ZM7.123,1.424A2.044,2.044,0,0,1,8.608.855,3.663,3.663,0,0,1,11.134,2a3.864,3.864,0,0,1,1.087,1.965l-.242.306h-5.1A2.506,2.506,0,0,1,7.123,1.424ZM.854,11.531V5.553a.427.427,0,0,1,.427-.427H9.822v6.833H1.281A.427.427,0,0,1,.854,11.531ZM2.989,24.77a.427.427,0,0,1-.427-.427V12.813h7.26V24.77Zm20.072-.427a.427.427,0,0,1-.427.427H15.8V12.813h7.26Zm1.708-12.812a.427.427,0,0,1-.427.427H15.8V5.126h8.541a.427.427,0,0,1,.427.427Zm0,0"
                  transform="translate(0 0)"
                  fill="#adacac"
                />
              </svg>
            </button>
          </template>
        </RoomBoxFooter>
        <div v-else></div>
      </template>

      <template v-slot:room-empty>
        <empty-room v-if="messages.length === 0 && messagesLoaded && activeRoom" :activeRoom="activeRoom" @message="firstMessage"></empty-room>
      </template>

      <template v-slot:rooms-empty>
        <div class="info-box">
          <div class="info-box__icon">
            <i class="demo-icon icon-users"></i>
          </div>
          <div class="info-box__title">
            {{ textMessages.ROOMS_EMPTY }}
          </div>
          <a :href="zRoute('front.members.index')" class="button button--tight button__outline mt-3">{{ trans.get('pages:chat.find_more') }}</a>
        </div>
      </template>

      <template v-slot:image="slotProps">
        <ChatImageAdmin v-if="activeRoom && activeRoom.profile.is_admin" v-bind="slotProps" @mediaUpdate="mediaUpdate" @buyMedia="buyMedia"></ChatImageAdmin>
        <ChatImage v-else v-bind="slotProps" @mediaUpdate="mediaUpdate" @buyMedia="buyMedia"></ChatImage>
      </template>

      <template v-slot:room-info="slotProps">
        <RoomInfoAdmin v-if="slotProps && slotProps.room && slotProps.room.profile && slotProps.room.profile.is_admin" v-bind="slotProps"></RoomInfoAdmin>
        <RoomInfo v-else v-bind="slotProps"></RoomInfo>
      </template>

      <template v-slot:rooms-item="slotProps">
        <RoomAdminItem v-if="slotProps.room.is_admin_special" v-bind="slotProps"></RoomAdminItem>
        <RoomItem v-else v-bind="slotProps"></RoomItem>
      </template>
    </chat-window>

    <div ref="galleries" v-if="activeRoom && !activeRoom.is_blocked && !activeRoom.profile.is_admin">
      <ImageGallery
        v-show="imageGallery"
        :fullWidth="chatWindowStatus.fullWidth"
        :roomId="activeRoomId"
        :profileId="activeRoomProfileId"
        @message="addMessage"
        @hide="imageGallery = false"
      ></ImageGallery>
      <GiftGallery
        v-show="giftGallery"
        :fullWidth="chatWindowStatus.fullWidth"
        :roomId="activeRoomId"
        :profileId="activeRoomProfileId"
        @message="addMessage"
        @hide="giftGallery = false"
      ></GiftGallery>
    </div>

    <div class="modal modal-v modal-v--normal fade" id="chatDeleteModal" tabindex="-1" role="dialog" aria-labelledby="chatDeleteModal" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body text-center">
            <h2 class="title title--medium mb-3 mt-md-0">{{ trans.get('pages:chat.messages_delete.title') }}</h2>
            <p>{{ trans.get('pages:chat.messages_delete.text') }}</p>
            <div class="row">
              <div class="col-12 mt-4">
                <button class="button button__fill button py-1" data-dismiss="modal">{{ trans.get('pages:chat.messages_delete.cancel') }}</button>
              </div>
              <div class="col-12 mt-4">
                <button @click="deleteMessagesAction()" data-dismiss="modal" class="button__link button__link--underline py-1" type="submit">
                  {{ trans.get('pages:chat.messages_delete.confirm') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="w-chat w-chat--recovery" v-else-if="user && isRecovery">
    <chat-recovery-loader></chat-recovery-loader>
  </div>
</template>

<script>
import ChatMixin from '../../../front/components/Chat/ChatMixin';
import ChatActionMixin from '../../../front/components/Chat/ChatActionMixin';
import ChatWindow from '../../../packages/vue-advanced-chat/src/ChatWindow';
import 'vue-advanced-chat/dist/vue-advanced-chat.css';
import EmptyRoom from './EmptyRoom';
import OnlineCard from './OnlineCard';
import ImageGallery from './ImageGallery';
import ChatImage from './ChatImage';
import RoomInfo from './RoomInfo';
import RoomItem from './RoomItem';
import RoomAdminItem from './RoomAdminItem.vue';
import GiftGallery from './GiftGallery';
import RoomBoxFooter from './RoomBoxFooter';
import RoomInfoAdmin from './RoomInfoAdmin';
import ChatImageAdmin from './ChatImageAdmin';

export default {
  name: 'ChatComponent',
  mixins: [ChatMixin, ChatActionMixin],
  components: {
    ChatImageAdmin,
    RoomInfoAdmin,
    RoomBoxFooter,
    GiftGallery,
    RoomItem,
    RoomAdminItem,
    RoomInfo,
    ChatImage,
    ImageGallery,
    OnlineCard,
    EmptyRoom,
    ChatWindow,
  },
  computed: {
    totalCoinsValue() {
      return this.user.coins + this.user.free_coins;
    }
  },
  mounted() {
    this.chatMixinMounted();
    this.chatActionMixinMounted();
  }
};
</script>
